import { DateRangeType } from '@fluentui/date-time-utilities/lib/dateValues/dateValues';
import { getCalendarSurfaceStore } from 'owa-calendar-surface-surface-store';
import { SurfaceConstants } from 'owa-calendar-surface-core';
import { getBrowserWidthBucket } from 'owa-layout';
import { getNumColumns } from './getNumColumns';
import { CalendarLayoutSplitViewConstants, CalendarLayoutLeftPaneConstants } from '../constants';
import { getNumDaysInDayRange } from 'owa-calendar-surface-options-utils';
import { shouldShowDynamicWeekColumns } from './shouldShowDynamicWeekColumns';
import { shouldShowAgendaPaneAsOverlay } from './shouldShowAgendaPaneAsOverlay';
import { getIsAgendaPaneShown } from './getIsAgendaPaneShown';
import { getIsLeftNavShown } from './getIsLeftNavShown';

export default function getCurrentColumnWidth() {
    const { dateRangeType, userOptions } = getCalendarSurfaceStore();
    const numWorkDays = userOptions.workDays ? userOptions.workDays.length : 5;
    const numColumns = getNumColumns();

    let currentColumnWidth = getBrowserWidthBucket();

    // if left nav is expanded, subtract leftPaneDefaultWidth from our available width
    if (getIsLeftNavShown()) {
        currentColumnWidth -= CalendarLayoutLeftPaneConstants.leftPaneDefaultWidth;
        currentColumnWidth -= SurfaceConstants.timeStripDefaultWidth;
    } else {
        currentColumnWidth -= CalendarLayoutLeftPaneConstants.leftRailStaticWidth;
        currentColumnWidth -= SurfaceConstants.timeStripDefaultWidth;
    }

    // if agenda pane is expanded, subtract $agendaViewWidth from our available width
    if (
        dateRangeType === DateRangeType.Month &&
        getIsAgendaPaneShown() &&
        !shouldShowAgendaPaneAsOverlay()
    ) {
        currentColumnWidth -= 320; // this is the $agendaViewWidth in CalendarAgendaPane.scss
    }

    // divide current width by number of columns in the surface
    // if showing dynamic column widths, decrease the factor we divide by since column widths will be larger
    if (shouldShowDynamicWeekColumns()) {
        currentColumnWidth /= numColumns * 0.8;
    } else {
        currentColumnWidth /= numColumns;
    }

    if (dateRangeType === DateRangeType.Week) {
        let minColumnWidth = CalendarLayoutSplitViewConstants.selectedCalendarMinWidth_WEEK / 7;
        return Math.max(currentColumnWidth, minColumnWidth);
    }
    if (dateRangeType == DateRangeType.WorkWeek) {
        let minColumnWidth =
            CalendarLayoutSplitViewConstants.selectedCalendarMinWidth_WEEK / numWorkDays;
        return Math.max(currentColumnWidth, minColumnWidth);
    }
    if (dateRangeType == DateRangeType.Day) {
        const minColumnWidth =
            CalendarLayoutSplitViewConstants.selectedCalendarMinWidth_DAY / getNumDaysInDayRange();

        return Math.max(currentColumnWidth, minColumnWidth);
    }
    return currentColumnWidth;
}
